import { useState } from 'react'

// 破冰問題產生器元件
function QuestionComponent() {
  // 所有題目（已移除原始那20題）
  const allQuestions = [
    // 🌍 文化與家鄉
    '你家鄉最常在什麼節日團聚？那天你們會做什麼？',
    '你國家的人通常早餐吃什麼？',
    '你們那裡約會的時候，通常去哪裡？',
    '在你家鄉，父母希望孩子成為什麼樣的人？',
    '介紹一個你們國家冷門的節日',
    '介紹一個你們國家的歷史名人',

    // ✈️ 旅行與世界觀
    '如果明天讓你選一個國家搬過去住，你會選哪裡？為什麼？',
    '你旅行的時候最在意什麼？吃？住？行程？還是…？',
    '你有沒有哪趟旅程是「一個人」去的？那次怎麼樣？',
    '你有沒有去過哪個地方，去了之後完全改變你對生活的看法？',

    // 🍜 生活與喜好
    '最近有什麼東西讓你上癮？',
    '你有沒有一個不實用但超喜歡的東西？',
    '你覺得你身上最不像別人的地方是什麼？',
    '你有沒有一種「別人覺得怪，但你很愛」的食物搭配？',
    '你有沒有一個荒謬但堅持的迷信？',
    '髒話', // 可用來開話題或創意說法
    '寫一張明信片給對方',

    // 🧠 想像與趣味
    '如果你是電影主角，你的角色職業會是什麼？',
    '如果你開一家「只賣沒用的東西」的店，你會賣什麼？',

    // 👥 人際與朋友
    '你身邊哪個朋友最怪？他做過什麼事？',

    // 💼 工作與職涯
    '你工作上最瘋狂或最好笑的一次經歷是什麼？',
    '在你工作領域裡，有沒有什麼外人不知道的有趣內幕？',
    '如果要讓5歲小孩也聽懂你的工作內容，你會怎麼解釋？',
    '你在工作上最有成就感的是哪一次？你有曾想辭職的瞬間嗎？',
    '如果不做現在的工作，你最想試試哪種工作？為什麼？',
    '你是怎麼踏進現在這份工作的？這是你計畫好的嗎？',

    // 🎓 教學與夢想
    '如果讓你開一堂課，你最想教什麼？為什麼？',
    '有沒有什麼事是你一直夢想去做而沒有去做的？'
  ]

  // 當前顯示的題目
  const [question, setQuestion] = useState('')

  // 剩下還沒被抽過的題目
  const [remaining, setRemaining] = useState([...allQuestions])

  // 點「下一題」時執行
  const getQuestion = () => {
    if (remaining.length === 0) {
      setQuestion('🎉 已經沒有新問題了！請按重新開始')
      return
    }

    // 隨機挑出一題
    const randomIndex = Math.floor(Math.random() * remaining.length)
    const newQuestion = remaining[randomIndex]

    // 剔除剛抽出的題目，避免重複
    const newRemaining = [...remaining]
    newRemaining.splice(randomIndex, 1)

    // 更新顯示題目與剩下題庫
    setQuestion(newQuestion)
    setRemaining(newRemaining)
  }

  // 點「重新開始」時執行
  const reset = () => {
    setRemaining([...allQuestions]) // 重設題庫
    setQuestion('')                 // 清空顯示文字
  }

  return (
    <div className="container text-center mt-5">
      <h2>🌟 Icebreaker Question Generator</h2>
      <p className="mt-4 fs-4">{question || '點下面開始吧！'}</p>
      <div className="mt-3">
        {/* 下一題按鈕 */}
        <button className="btn btn-primary" onClick={getQuestion}>下一題</button>
        
        {/* 重新開始按鈕 */}
        <button className="btn btn-secondary ms-2" onClick={reset}>重新開始</button>
      </div>
    </div>
  )
}

export default QuestionComponent